import { render, staticRenderFns } from "./ProjectTemplate1.vue?vue&type=template&id=e35f4310&scoped=true"
import script from "./ProjectTemplate1.vue?vue&type=script&lang=js"
export * from "./ProjectTemplate1.vue?vue&type=script&lang=js"
import style0 from "./ProjectTemplate1.vue?vue&type=style&index=0&id=e35f4310&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35f4310",
  null
  
)

export default component.exports